import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { CheckboxGroup, CheckboxWithText } from 'components'
import * as Types from 'types'
import {
  formatObjectsToIds,
  parseIdsToObjects,
  yankBy,
  serializeOptions,
  isOtherType,
} from 'utils'

const propTypes = {
  programTypes: PropTypes.arrayOf(Types.resourceType).isRequired,
  prefix: PropTypes.string,
}

function PartnerProgramTypeForm({ programTypes, prefix = '' }) {
  const [otherProgramType, definedProgramTypes] = useMemo(
    () => yankBy(programTypes, isOtherType),
    [programTypes]
  )
  const base = prefix ? `${prefix}.` : ''
  return (
    <div>
      <Field
        name={`${base}requestedProgramTypes`}
        label={false}
        component={CheckboxGroup}
        format={formatObjectsToIds('programTypeId')}
        parse={parseIdsToObjects('programTypeId')}
        options={serializeOptions(definedProgramTypes)}
      />
      <Field
        name={`${base}otherText`}
        label={otherProgramType.displayName}
        placeholder="Description..."
        component={CheckboxWithText}
      />
    </div>
  )
}

PartnerProgramTypeForm.propTypes = propTypes
export default PartnerProgramTypeForm
